import { useQueries } from 'react-query';
import axios from 'axios';
import {
    COMMON_APPLICATION_CONFIG_URL,
    getJsonPath,
} from '../utils/constants';
import { fetchAndMergeConfigJsonFiles } from '../utils/fetchAndMergeJsonFiles';
import { AppConfigurationType } from '../store/types';
import JsonFilePath from '../utils/jsonFilePath';

const useFetchAppConfiguration = (appVersionNumber: string) => (
    useQueries([
        {
            queryKey: ['app-configuration-fetch', appVersionNumber],
            queryFn: () => (
                fetchAndMergeConfigJsonFiles<AppConfigurationType>(
                    JsonFilePath.APP_CONFIGURATION_JSON,
                    appVersionNumber,
                )
            ),
        },
        {
            queryKey: ['qz-configuration-fetch', appVersionNumber],
            queryFn: () => axios.get(
                getJsonPath(
                    JsonFilePath.QZ_CONFIGURATION_JSON.path,
                    { configUrl: COMMON_APPLICATION_CONFIG_URL, appVersionNumber },
                ),
            ),
        },
    ])
);

export default useFetchAppConfiguration;
